<div (click)="toggleMenu()">
  <ng-content select="atx-accordion-header"></ng-content>
</div>
@if (open || animate) {
<div
  data-e2e="accordion-body"
  [id]="panelId"
  [ngClass]="panelBodyClass"
  [class.overflow-hidden]="animate"
  [@slideInOut]="animate ? (open ? 'open' : 'closed') : 'open'"
>
  <ng-template #simpleContent>{{ content }}</ng-template>
  <ng-template
    [ngTemplateOutlet]="isTemplate(content) ? content : simpleContent"
  ></ng-template>
</div>
}
